import React, { Dispatch, SetStateAction } from 'react';
import { useTranslates } from 'providers/translates';
import { Dialog, Stack } from '@mui/material';
import styles from './styles.module.scss';

export const DefaultDialog: React.FC<{
  open: boolean;
  setDialog: Dispatch<SetStateAction<boolean>>;
  title: string;
  text: string;
  confirmAction: () => void;
  confirmBtnText?: string;
  cancelBtnText?: string;
  noCancelBtn?: boolean;
}> = ({
  open,
  setDialog,
  title,
  text,
  confirmAction,  
  noCancelBtn,
  confirmBtnText
}) => {
  const handleClose = () => setDialog(false);
  const { translates: t } = useTranslates();
  const addAPhoto = t?.quiltBuilderStepOne?.addAPhoto;
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          maxWidth: '700px',
        },
      }}
    >
      <Stack justifyContent="center" alignItems="center" p={3} spacing={2}>
        <div className={`inputWithTitle ${styles.centeredText}`}>
          <span className={styles.noCapitalize}>{title}</span>
        </div>

        <div className={`${styles.text}`} dangerouslySetInnerHTML={{ __html: text || '' }}></div>

        <Stack direction="row" spacing={2} pt={1}>
          {!noCancelBtn && (
            <button className={`customButton ${styles.button}`} onClick={handleClose}>
              {t?.buttonsForTheSite?.no ?? 'No'}
            </button>
          )}
          <button className={`customButton ${styles.button}`} onClick={confirmAction}>
            {confirmBtnText ?? 'OK'}
          </button>
        </Stack>
      </Stack>
    </Dialog>
  );
};
